import { render, staticRenderFns } from "./ExcelTemplateBasedReport.vue?vue&type=template&id=30b1aa8a"
import script from "./ExcelTemplateBasedReport.vue?vue&type=script&lang=js"
export * from "./ExcelTemplateBasedReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports